import {Component, Inject} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

/**
 * Data passed into {@link PromptDialogComponent}. Mirrors the field names
 * used by the project's existing {@link ConfirmDialogComponent} for
 * consistency.
 *
 *  - `title`        — dialog title (already-translated string).
 *  - `body`         — optional body text shown above the input.
 *  - `label`        — floating label of the input field.
 *  - `initialValue` — initial value of the input.
 *  - `okButton`     — text on the confirm button.
 *  - `cancelButton` — text on the cancel button.
 *  - `placeholder`  — optional placeholder for the input.
 */
export interface PromptDialogData {
  title: string;
  body?: string;
  label: string;
  initialValue: string;
  okButton: string;
  cancelButton: string;
  placeholder?: string;
}

/**
 * Material-dialog replacement for `window.prompt(...)`. Returns the
 * trimmed string value via `dialogRef.afterClosed()` on confirm, or
 * `undefined` on cancel.
 */
@Component({
  selector: 'app-prompt-dialog',
  templateUrl: './prompt-dialog.component.html'
})
export class PromptDialogComponent {
  value: string;

  constructor(public dialogRef: MatDialogRef<PromptDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: PromptDialogData) {
    this.value = (data && typeof data.initialValue === 'string') ? data.initialValue : '';
  }

  onCancel(): void {
    this.dialogRef.close(undefined);
  }

  onOk(): void {
    const trimmed = (this.value || '').trim();
    this.dialogRef.close(trimmed.length > 0 ? trimmed : undefined);
  }
}

